import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../Redux/Store";
import SnackBarComponent from "../../SnackBar/SnackBar";
import {
  TextField,
  InputAdornment,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  MenuItem,
  Grid,
  Icon,
} from "@material-ui/core";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import { patientsList, patientsListChild } from "./PatientConfig";
import ReactTableComponent from "../../ReactTable/ReactTable";
import { FadeLoader } from "react-spinners";
import "./patients.css";
import { patientListQuery, siteListQuery, saveCTScan } from "./PatientQuery";
import { fetchMethod, debounce, formatDate } from "../../FetchMethod";
import { mutationQueries } from "../../MutationMethod";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import moment from "moment";
import EditIcon from "./../../DumbAssets/EditIcon";
import gql from "graphql-tag";
const iconComponent = (props) => {
  return (
    <Icon className={props.className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.992"
        height="8"
        viewBox="0 0 13.992 8"
        style={{
          fill: "#69BAFE",
          // width: "23px",
          height: "auto",
        }}
      >
        <defs></defs>
        <path
          className="a"
          d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
          transform="translate(-6.188 -11.246)"
        />
      </svg>
    </Icon>
  );
};
class Patients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isCTUploadPermission: store.getState().Permission
        ? store.getState().Permission.CT_UPLOAD_PERMISSION
        : false,
      isActionPermission: store.getState().Permission
        ? store.getState().Permission.USER_SITE_FILE_PERMISSION
        : false,
      siteData: [],
      allSiteData: [],
      site: "",
      search: "",
      pageNo: parseInt(localStorage.getItem("rows")),
      rows: parseInt(localStorage.getItem("rows")),
      listData: undefined,
      count: 0,
      isAscSort: true,
      filter: { active: 1, order: "updatedon desc" },
      loading: true,
      deleteid: 0,
      deletemodalOpen: false,
      preliminaryanalysispath: "",
      treatmentplanpath: "",
      preliminaryAnalysisData: [
        { id: 1, name: "Done" },
        {
          id: 0,
          name: "Pending",
        },
      ],
      Ip3TreatmentData: [
        { id: 1, name: "Done" },
        {
          id: 0,
          name: "Pending",
        },
      ],
    };
  }
  componentDidMount() {
    this.props.sideBarPath("/patients");
    this.getlistData();
    this.siteListData();
  }
  siteListData = () => {
    fetchMethod(siteListQuery, {
      where: { active: 1 },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }
        if (res.data.allSites.Sites) {
          this.setState({
            siteData: res.data.allSites.Sites.map((item) => {
              item.name = item.name.includes(",")
                ? item.name
                : item.siteid + "," + item.name;
              return item;
            }),
            allSiteData: res.data.allSites.Sites.map((item) => {
              item.name = item.name.includes(",")
                ? item.name
                : item.siteid + "," + item.name;
              return item;
            }),
          });
        }
      })
      .catch((e) => {
        this.setState({ loading: false });
        console.log(e);
      });
  };
  getlistData = async () => {
    this.setState({ listData: [], loading: true });
    const variable={
      where: this.state.filter,
      last: this.state.rows,
      first: this.state.pageNo,
    }
    fetchMethod(patientListQuery, variable)
      .then((res) => res.json())
      .then(async (res) => {
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }
        let query = "";
        if (res.data.allCtscans) {
          let ctscanlist = res.data.allCtscans.Ctscans;
          res.data.allCtscans.Ctscans.map((item, index) => {
            let scandate = item.scandate;
            if (item.scandate)
              scandate = moment(item.scandate).format("MMM DD, YYYY");
            // query += `id${index}:allSites(where:{siteid:"${item.siteid}"}){
            //   Sites {
            //     name
            //   }
            // }`;
            query += `id${index}:allSites(where:{id:${item.siteid}}){
              Sites {
                name
                siteid
              }
            }`;
            return Object.assign(item, { scandate: scandate });
          });
          if (query !== "") {
            await fetchMethod(gql`query{${query}}`)
              .then((res) => res.json())
              .then((result) => {
                res.data.allCtscans.Ctscans.map((items, index) => {
                  items.site = result.data[`id${index}`].Sites
                    ? result.data[`id${index}`].Sites.length
                      ? result.data[`id${index}`].Sites[0].siteid +
                        "," +
                        result.data[`id${index}`].Sites[0].name
                      : ""
                    : "";
                  return items;
                });
                this.setState({
                  // listData:results,
                  count: res.data.allCtscans.totalCount,
                  loading: false,
                  fullListData: res.data.allCtscans.Ctscans,
                });
              })
              .catch((e) => {
                this.setState({
                  open: true,
                  severity: "error",
                  alertmsg: e.message,
                  loading: false,
                });
                console.log(e);
              });
          } else {
            this.setState({
              // listData: dis,
              count: res.data.allCtscans.totalCount,
              loading: false,
              fullListData: res.data.allCtscans.Ctscans,
            });
          }
          // DISTINCT ARRAY AND EXPANDABLE VALUE
          const results = [];
          const map = new Map();
          ctscanlist.map((item) => {
            if (!map.has(item.intervaporid)) {
              map.set(item.intervaporid, item.id); // set any value to Map
              results.push(item);
            } else {
              let expandableArray = ctscanlist.filter(
                (it) =>
                  it.intervaporid == item.intervaporid &&
                  it.id !== map.get(item.intervaporid)
              );
              results.map((resultitem) => {
                if (resultitem.intervaporid === item.intervaporid)
                  resultitem.subArray = expandableArray.map((subitems) => {
                    if (subitems.preliminaryanalysispath)
                      subitems.preliminaryanalysispath = "Done";
                    else subitems.preliminaryanalysispath = "Pending";
                    if (subitems.treatmentplanpath)
                      subitems.treatmentplanpath = "Done";
                    if (subitems.ip3requestedon && !subitems.treatmentplanpath)
                      subitems.treatmentplanpath = "Pending";
                    return subitems;
                  });
              });
            }
          });
          results.map((resultitem) => {
            if (resultitem.preliminaryanalysispath)
              resultitem.preliminaryanalysispath = "Done";
            else resultitem.preliminaryanalysispath = "Pending";
            if (resultitem.treatmentplanpath)
              resultitem.treatmentplanpath = "Done";
            if (resultitem.ip3requestedon && !resultitem.treatmentplanpath)
              resultitem.treatmentplanpath = "Pending";
          });
          this.setState({
            listData: results,
            loading: false,
          });
        }
        if (res.errors) {
          this.setState({
            loading: false,
          });
        }
      })
      .catch((e) => {
        this.setState({ loading: false });
        console.log(e);
      });
  };
  sortByHeader = (item) => {
    if (item === "intervaporid") {
      const { filter } = this.state;

      let { sortingParam, isAscSort } = this.state;

      if (this.state.isAscSort) {
        filter["order"] = "intervaporid DESC";
        sortingParam = "intervaporid";
        isAscSort = false;
      } else {
        sortingParam = item;
        filter["order"] = "intervaporid ASC";
        isAscSort = true;
      }

      this.setState(
        {
          filter,
          sortingParam,
          isAscSort,
        },
        () => this.getlistData()
      );
    }
  };
  updatePagination = (pageNumber, size) => {
    this.setState(
      {
        pageNo: pageNumber,
        rows: size,
      },
      () => {
        this.getlistData();
      }
    );
  };
  handleSearch = (e) => {
    let { name, value } = e.target;
    let { filter } = this.state;
    filter["and"] = [
      {
        or: [
          { intervaporid: { like: `%${value}%` } }
          // { scanseriesuid: { like: `%${value}%` } },
        ],
      },
    ];
    this.setState({ [name]: value, filter, pageNo: this.state.rows }, () => {
      this.debounceTimer = debounce(
        this.debounceTimer,
        () => {
          this.getlistData();
        },
        200
      );
    });
  };
  handleSearchSite = (e, value) => {
    let { sitefilter, siteData, allSiteData , filter } = this.state;
    if (value) {
      sitefilter = { name: { like: `%${value}%` }, active: 1 };
      let PATTERN = RegExp(value ? value : "", "i");
      siteData = allSiteData.filter((items) => PATTERN.test(items.name));
      this.setState({ site: value, sitefilter, pageNo: this.state.rows }, () =>
        this.state.site.length >= 2 ? this.setState({ siteData }) : ""
      );
    } else {
      filter && filter.siteid && delete filter.siteid
      this.setState({ site: value, filter },()=>this.getlistData());
      this.siteListData();
      this.getlistData();
    }
  };
  searchSite = (e, value) => {
    let { filter } = this.state;
    // if (value) filter["siteid"] = value.siteid;
    if (value) {
      if (Array.isArray(filter)) filter={}
      filter["siteid"] = value ? value.id : "";
    }
    else delete filter.siteid;
    this.setState({ filter, pageNo: this.state.rows }, () =>
      this.getlistData()
    );
  };
  handleAutoComplete = (e, value) => {
    let { filter } = this.state;
    let { name } = e.target;
    filter[name] = value;
    this.setState({ [name]: value }, () => {
      this.getlistData();
    });
  };

  handleSnackBarClose = () => {
    // let { severity } = this.state;
    // this.setState({ open: false, severity: "", alertmsg: "" });
    if (this.state.open === true) {
      this.props.history.push("/patients");
      this.setState({ open: false });
    }
  };

  clearFilter = () => {
    this.setState(
      {
        search: "",
        site: "",
        preliminaryanalysispath: "",
        treatmentplanpath: "",
        filter: { active: 1, order: "updatedon desc" },
        siteData: this.state.allSiteData,
      },
      () => this.getlistData()
    );
  };
  uploadCT = () => {
    this.props.history.push("/upload-CT");
  };
  handleClose = (id) => {
    this.setState((prevState) => {
      return { deletemodalOpen: !prevState.deletemodalOpen, deleteid: id };
    });
  };
  handleDelete = () => {
    const deleteobj = {
      id: this.state.deleteid,
      active: 0,
    };

    this.setState({ loading: true });
    mutationQueries(saveCTScan, { obj: deleteobj })
      .then((res) => {
        this.setState({ loading: false });
        const id = res.data.saveCtscans.id;
        if (id) {
          let pageNo = this.state.pageNo;
          let previousData = this.state.listData.length;
          this.setState({ listData: undefined });

          const { filter } = this.state;

          let search = this.state.search;

          if (this.state.search !== "" && previousData === 1) {
            pageNo = this.state.rows;
            delete filter["and"];
            search = "";
          } else if (
            this.state.search === "" &&
            previousData === 1 &&
            pageNo !== this.state.rows
          ) {
            pageNo = this.state.pageNo - this.state.rows;
          } else {
            pageNo = this.state.pageNo;
          }

          this.setState(
            {
              pageNo,
              filter,
              search,
              deletemodalOpen: false,
              deleteid: 0,
              open: true,
              severity: "success",
              alertmsg: "Patient Deleted Successfully !",
            },
            () => this.getlistData()
          );
        }
      })
      .catch((e) => console.log(e));
  };
  handleSelect = (e) => {
    const {
      target: { name, value },
    } = e;
    let { filter } = this.state;
    if (name === "preliminaryanalysispath" || name === "treatmentplanpath") {
      let filtered =
        filter["and"] && filter["and"].length ? { ...filter["and"] }[0] : null;
      filtered = filtered ? filtered.and : null;
      let filterKeys = filtered
        ? filtered.map((items) => Object.keys(items)[0])
        : null;
      let fil = filterKeys ? filterKeys.filter((item) => item == name) : null;
      if (fil && fil.length)
        filtered = filtered
          ? filtered.map((items) => {
              return Object.keys(items)[0] === name
                ? value
                  ? Object.assign(items, { [name]: { neq: "" } })
                  : Object.assign(items, { [name]: { eq: null } })
                : items;
            })
          : null;
      else if (!fil)
        value
          ? (filtered = [{ [name]: { neq: "" } }])
          : (filtered = [{ [name]: { eq: null } }]);
      else
        filtered.push(
          value ? { [name]: { neq: "" } } : { [name]: { eq: null } }
        );

      filter["and"] = [
        {
          and: filtered ? filtered : [],
        },
      ];
    } else filter[name] = value;
    this.setState({ filter, pageNo: this.state.rows, [name]: value }, () =>
      this.getlistData()
    );
  };
  editForm = (id) => {
    this.props.history.push({ pathname: "edit-upload-CT", state: { id: id } });
  };
  subComponent = (row) => {
    const TheadComponent = (props) => null; // a component returning null (to hide) or you could write as per your requirement
    const nameAndImage = [
      {
        Header: () => {
          return (
            <div style={{ cursor: "pointer" }}>
              InterVapor ID
              {this.state.isAscSort ? <ArrowUpward /> : <ArrowDownward />}
            </div>
          );
        },
        accessor: "intervaporid1",
      },
    ];

    const actions = [
      { Cell:(row)=><div style={{width:"35px"}}></div> },
      {
        Header: "Action",
        sortable: false,
        Cell: (row) =>
          this.state.isActionPermission ? (
            <div className="actions exapandedAction">
              <IconButton
                className="editicon"
                onClick={() => this.editForm(row.original.id)}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                className="deleteicon"
                onClick={() => this.handleClose(row.original.id)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15.75"
                  height="18"
                  viewBox="0 0 15.75 18"
                >
                  <defs></defs>
                  <path
                    className="a"
                    d="M15.187,1.125H10.969l-.33-.657A.844.844,0,0,0,9.882,0H5.864a.834.834,0,0,0-.752.468l-.33.657H.562A.562.562,0,0,0,0,1.687V2.812a.562.562,0,0,0,.562.562H15.187a.562.562,0,0,0,.562-.562V1.687A.562.562,0,0,0,15.187,1.125ZM1.87,16.418A1.687,1.687,0,0,0,3.554,18H12.2a1.687,1.687,0,0,0,1.684-1.582L14.625,4.5H1.125Z"
                  />
                </svg>
              </IconButton>
            </div>
          ) : (
            <div className="actions">
              <IconButton
                className="editiconchild"
                onClick={() => this.editForm(row.original.id)}
              >
                <VisibilityOutlinedIcon />
              </IconButton>
            </div>
          ),
      },
    ];
    const columns = nameAndImage
      .concat(patientsListChild.columns)
      .concat(actions);
    return (
      <div className="PatientChild">
        {row.original.subArray ? (
          <ReactTableComponent
            listData={row.original.subArray}
            listConfig={patientsListChild}
            TheadComponent={TheadComponent}
            columns={columns}
            dataCount={this.state.count}
            initialPage={this.state.pageNo / this.state.rows}
            forSerialNo={{
              pageNo: this.state.pageNo,
              pageSize: this.state.rows,
            }}
          />
        ) : (
          ""
        )}
      </div>
    );
  };
  render() {
    const nameAndImage = [
      {
        Header: () => {
          return (
            <div style={{ cursor: "pointer" }}>
              InterVapor ID
              {this.state.isAscSort ? <ArrowUpward /> : <ArrowDownward />}
            </div>
          );
        },
        accessor: "intervaporid",
      },
    ];

    const actions = [
      {
        expander: true,
        Expander: ({ isExpanded, ...rest }) => {
          if (rest.original.subArray && rest.original.subArray.length > 0) {
            return (
              <div>
                {isExpanded ? (
                  <span className="expansionCarot">
                    <ExpandLessIcon />
                  </span>
                ) : (
                  <span className="expansionCarot">
                    <ExpandMoreIcon />
                  </span>
                )}
              </div>
            );
          } else {
            return "";
          }
        },
      },
      this.state.isActionPermission
        ? {
            Header: () => {
              return <span>Action</span>;
            },

            sortable: false,
            Cell: (row) => (
              <div className="actions">
                <IconButton
                  className="editicon"
                  onClick={() => this.editForm(row.original.id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                  >
                    <defs></defs>
                    <path
                      className="a"
                      d="M4.5,18.747V22.5H8.249L19.308,11.438,15.558,7.688ZM22.207,8.538a1,1,0,0,0,0-1.41l-2.34-2.34a1,1,0,0,0-1.41,0l-1.83,1.83,3.749,3.749Z"
                      transform="translate(-4.5 -4.496)"
                    />
                  </svg>
                </IconButton>
                <span style={{ marginLeft: "-10px" }}>
                  <IconButton
                    className="deleteicon"
                    onClick={() => this.handleClose(row.original.id)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15.75"
                      height="18"
                      viewBox="0 0 15.75 18"
                    >
                      <defs></defs>
                      <path
                        className="a"
                        d="M15.187,1.125H10.969l-.33-.657A.844.844,0,0,0,9.882,0H5.864a.834.834,0,0,0-.752.468l-.33.657H.562A.562.562,0,0,0,0,1.687V2.812a.562.562,0,0,0,.562.562H15.187a.562.562,0,0,0,.562-.562V1.687A.562.562,0,0,0,15.187,1.125ZM1.87,16.418A1.687,1.687,0,0,0,3.554,18H12.2a1.687,1.687,0,0,0,1.684-1.582L14.625,4.5H1.125Z"
                      />
                    </svg>
                  </IconButton>
                </span>
              </div>
            ),
          }
        : {
            Header: () => {
              return <span>Action</span>;
            },
            sortable: false,
            Cell: (row) => (
              <div className="actions">
                <IconButton
                  className="editiconchild"
                  onClick={() => this.editForm(row.original.id)}
                >
                  <VisibilityOutlinedIcon />
                </IconButton>
              </div>
            ),
          },
    ];
    const columns = nameAndImage.concat(patientsList.columns).concat(actions);

    return (
      <div className="patients">
        {this.state.loading ? (
          <div className="Loader">
            <FadeLoader
              style={{ height: "15", width: "5", radius: "2" }}
              color={"#6FABF0"}
              loading={this.state.loading}
            />
          </div>
        ) : (
          ""
        )}
        <h1>Patients</h1>
        <div className="PatientFilterSection">
          <div>
            <TextField
              variant="outlined"
              placeholder="By InterVapor ID"
              label="Search"
              name="search"
              autoComplete="off"
              value={this.state.search}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={this.handleSearch}
            />
          </div>
          <div>
            <Autocomplete
              freeSolo
              id="controllable-states-demo"
              name="site"
              // className="selectFields siteStatus"
              getOptionLabel={(option) => (option.name ? option.name : "")}
              inputValue={this.state.site}
              onInputChange={this.handleSearchSite}
              onChange={this.searchSite}
              options={this.state.siteData}
              variant="outlined"
              disableClearable
              forcePopupIcon={true}
              popupIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.992"
                  height="8"
                  viewBox="0 0 13.992 8"
                  style={{ fill: "#69BAFE", marginRight: "5px" }}
                >
                  <defs></defs>
                  <path
                    className="a"
                    d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
                    transform="translate(-6.188 -11.246)"
                  />
                </svg>
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="siteStatus"
                  label="Site"
                  variant="outlined"
                />
              )}
            />
          </div>
          <div>
            <TextField
              labelid="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              variant="outlined"
              className="preliminarySelect"
              select
              value={this.state.preliminaryanalysispath}
              onChange={this.handleSelect}
              label="Preliminary Analysis"
              name="preliminaryanalysispath"
              SelectProps={{
                IconComponent: iconComponent,
              }}
            >
              {this.state.preliminaryAnalysisData.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
          <div>
            <TextField
              className="Ip3Select"
              labelid="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              variant="outlined"
              select
              value={this.state.treatmentplanpath}
              onChange={this.handleSelect}
              label="IP3 Treatment Plan"
              name="treatmentplanpath"
              SelectProps={{
                IconComponent: iconComponent,
              }}
            >
              {this.state.Ip3TreatmentData.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
          {this.state.site ||
          this.state.search ||
          this.state.preliminaryanalysispath ||
          this.state.preliminaryanalysispath === 0 ||
          this.state.treatmentplanpath ||
          this.state.treatmentplanpath === 0 ? (
            <Button className="resetBtn" onClick={this.clearFilter}>
              Reset
            </Button>
          ) : (
            ""
          )}
          {this.state.isCTUploadPermission ? (
            <Button className="addsiteBtn" onClick={this.uploadCT}>
              Upload CT
            </Button>
          ) : (
            ""
          )}
        </div>
        {/* -- Snack Bar Component -- */}
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            timer={1000}
            handleClose={this.handleSnackBarClose}
            className="addUserSnackBar"
          />
        ) : (
          ""
        )}
        {/* -- Snack Bar Component -- */}
        <div className="PatientTableSection">
          {this.state.listData ? (
            <ReactTableComponent
              listData={this.state.listData}
              listConfig={patientsList}
              columns={columns}
              dataCount={this.state.count}
              onHeaderClick={this.sortByHeader}
              updatePagination={this.updatePagination}
              initialPage={this.state.pageNo / this.state.rows}
              forSerialNo={{
                pageNo: this.state.pageNo,
                pageSize: this.state.rows,
              }}
              subComponent={this.subComponent}
              expansion={true}
            />
          ) : (
            ""
          )}
        </div>
        <Dialog
          open={this.state.deletemodalOpen}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleClose} className="cancelbtn">
              Cancel
            </Button>
            <Button
              onClick={this.handleDelete}
              autoFocus
              className="confirmbtn"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    sideBarPath: (route) =>
      dispatch({ type: "Show_Sidebar_Route", payload: route }),
  };
};

export default connect(null, mapDispatchToProps)(Patients);
